<template>
  <div class="mail-mag-config">
    <app-loading class="loading" :isLoading="isLoading"></app-loading>
    <p class="mail-mag-config__lead">
      お知らせや新着メニューの紹介、割引情報、先行予約などお得な情報をお送りします。<br>
      ご希望のメールマガジンをお選びください。
    </p>
    <form
      ref="form"
      :action="postUrl"
      method="post"
    >
      <input type="hidden" name="_token" :value="csrfToken" />
      <ul class="magazine-list">
        <template v-for="(item, index) in magazineListMod">
          <li class="mag-item" :data-id="`id${item.id}`" :key="index">
            <base-checkbox
              name="magazine_id[]"
              :value="String(item.id)"
              :label="item.name"
              :isChecked="item.checked"
              :validation="{ rules: {required: true} }"
              @change="changeChecked"
            />
          </li>
        </template>
      </ul>
      <base-button
        class="mail-mag-config__submit"
        label="更新"
        :is-disabled="!isSubmitEnable || (isSubmitEnable && isLoading)"
        @clicked="checkForm"
      />
    </form>
  </div>
</template>

<script>
import BaseButton from '../common/BaseButton'
import BaseCheckbox from '../common/BaseCheckbox'

export default {
  name: "MailMagConfig",
  components: {
    BaseButton,
    BaseCheckbox
  },
  data () {
    return {
      isSubmitEnable: false,
      checkedArray: [],
      initialArray: {},
      formList: [],
      isLoading: false
    }
  },
  props: {
    postUrl: {
      type: String,
      default() {
        return ''
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    magazineList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  computed: {
    magazineListMod() {
      if (this.magazineList.length > 0) {
        return this.magazineList.sort(((key, order = 'asc') => {
          return (a, b) => {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0
            const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
            const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]
            let comparison = 0
            if (varA > varB) {
              comparison = 1
            } else if (varA < varB) {
              comparison = -1
            }
            return (order === 'desc') ? (comparison * -1) : comparison
          }
        })('sort_key', 'asc'))
      }else{
        return []
      }
    },
  },
  mounted(){
    this.isLoading = false
    const forms = this.$el.querySelector('.magazine-list')
    this.checkedArray.splice(0)
    for(let [index, item] of this.magazineListMod.entries()){
      this.initialArray[`id${item.id}`] = {
        checked: item.checked,
        id: item.id
      }
      this.checkedArray.push({
        id: item.id,
        checked: item.checked,
        elm: forms.querySelector(`li[data-id=id${item.id}] input[type=checkbox]`)
      })
    }
  },
  methods: {
    /**
     * change の時の処理
     * @return {Void} 条件に合うデータを変更
     */
    changeChecked () {
      let chk = false
      for(let item of this.checkedArray){
        chk = this.initialArray[`id${item.id}`].checked !== item.elm.checked ? true : chk
        item.checked = item.elm.checked
      }
      this.isSubmitEnable = chk
    },
    /**
     * form submit処理
     * @return {Void}
     */
    checkForm () {
      if(!this.isLoading) {
        this.isLoading = true
        this.$refs.form.submit()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.mail-mag-config {
  color: $col_base_black;
  padding: 32px 4px 30px;
  .loading {
    position: fixed;
    z-index: 3;
    top: 45vh;
    left: 0;
    right: 0;
    margin: auto;
  }
  &__lead {
    font-size: 13px;
    margin: 0 0 22px;
  }
}

.magazine-list {
  padding: 20px;
  margin: 0 0 35px;
  border: 1px solid $col_temp_gray3;
  border-radius: 7px;
  .mag-item {
    display: block;
    margin: 0 0 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
.mail-mag-config .baseButton__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/MailMagConfig.vue